import React from 'react';
import Section from './Section';
import SafeIcon from '../common/SafeIcon';
import { FiAlertCircle, FiEyeOff, FiTrendingDown } from 'react-icons/fi';

const Problem = () => {
  return (
    <div className="bg-zinc-100 border-y border-zinc-200">
      <Section>
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-6">
            You’re Sharing More Than You Think
          </h2>
          <p className="text-xl text-zinc-600 mb-10">
            Apps quietly collect your location, contacts, and behavior in the background. This data is routinely packaged and shared with third parties. Most users simply click "Allow" without understanding the real-world consequences.
          </p>
          
          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="mt-1 p-2 bg-white rounded-md shadow-sm border border-zinc-200">
                <SafeIcon icon={FiEyeOff} className="w-6 h-6 text-zinc-900" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-zinc-900">You don’t know who has your data</h3>
                <p className="text-zinc-600">Your information passes through dozens of brokers and aggregators.</p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="mt-1 p-2 bg-white rounded-md shadow-sm border border-zinc-200">
                <SafeIcon icon={FiTrendingDown} className="w-6 h-6 text-zinc-900" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-zinc-900">You don’t know how it’s used</h3>
                <p className="text-zinc-600">It's not just ads. It's profiling, risk assessment, and behavioral prediction.</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="mt-1 p-2 bg-white rounded-md shadow-sm border border-zinc-200">
                <SafeIcon icon={FiAlertCircle} className="w-6 h-6 text-zinc-900" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-zinc-900">You don’t know what it can lead to</h3>
                <p className="text-zinc-600">From manipulated pricing to compromised personal safety, the risks are tangible.</p>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </div>
  );
};

export default Problem;